import { lazy } from 'react';

import Address from '../features/admin/components/address/Address';
import EditTagModal from '../features/lead-management/components/edit-tag-modal/EditTagModal';
import MobileNumberInput from '../features/lead-management/components/mobile-number-input/MobileNumberInput';
import ConfirmationModal from '../layouts/modal/ConfirmationModal';
import Modal from '../layouts/modal/Modal';
import Accordion from './accordion/Accordion';
import AccountFooter from './account-footer/AccountFooter';
import ActionButton from './action-button/ActionButton';
import AddMemberModal from './add-member-modal/AddMemberModal';
import AmountInput from './amount-input/AmountInput';
import AmountInputTooltip from './amount-input-tooltip/AmountInputTooltip';
import Avatar from './avatar/Avatar';
import BackWithCustomText from './back-with-custom-text/BackWithCustomText';
import BlacklistedModal from './blacklisted-modal/BlacklistedModal';
import Breadcrumbs from './breadcrumbs/Breadcrumbs';
import BusinessNameInfoBanner from './business-name-info-banner/BusinessNameInfoBanner';
import Button from './button/Button';
import Checkbox from './checkbox/Checkbox';
import Chip from './chip/Chip';
import ContactSupport from './contact-support/ContactSupport';
import CopyToClipboard from './copy-to-clipboard/CopyToClipboard';
import CountryCode from './country-code/CountryCode';
import DatePicker from './date-picker/DatePicker';
import DateRangePicker from './date-range-picker/DateRangePicker';
import DowntimeTimer from './down-time-timer/DownTimeTimer';
import Drawer from './drawer/Drawer';
import Dropdown from './drop-down/Dropdown';
import DropdownWithRadoiButton from './drop-down/DropdownWithRadioButton';
import DropDownActionButton from './dropdown-action-button/DropDownActionButton';
import BarLineComboChart from './e-charts/bar-line-combo-chart/BarLineComboChart';
import DonutChart from './e-charts/donut-chart/DonutChart';
import EmptyScreen from './empty-screen/EmptyScreen';
import FeeConfigInput from './fee-config-input/FeeConfigInput';
import FloatingBottomBar from './floating-bottom-bar/FloatingBottomBar';
import GroupCard from './group-card/GroupCard';
import Icon from './icon/Icon';
import ImageUpload from './image-upload/ImageUpload';
import ImageUploadBranch from './image-upload-branch/ImageUploadBranch';
import InfiniteScroll from './infinite-scroll/InfiniteScroll';
import InfoCard from './info-card/InfoCard';
import InfoIconTooltip from './info-icon-tooltip/InfoIconTooltip';
import Input from './input/Input';
import Label from './label/Label';
import LabelledNumberStepper from './labelled-segmented-number-stepper/LabelledNumberStepper';
import LogoUpload from './logo-upload/LogoUpload';
import MultiFieldFilter from './multi-field-filter/MultiFieldFilter';
import MultiProgressBar from './multi-progress-bar/MultiProgressBar';
import MultiSelectFilter from './multi-select-filter/MultiSelectFilter';
import MultiSelector from './multi-selector/MultiSelector';
import MultiSelectorWithChips from './multi-selector-with-chips/MultiSelectorWithChips';
import MultiUpload from './multi-upload/MultiUpload';
import MultiSelectDropdown from './multiselect-dropdown/MultiSelectDropdown';
import MultiSelectDropdownV2 from './multiselect-dropdown/MultiSelectDropdownV2';
import MulitSelectDropdownWithApplyButton from './multiselect-dropdown/MultiSelectDropdownWithApplyButton';
import NextPageButton from './next-page-button/NextPageButton';
import Notification from './notification/Notification';
import OrgPreApprovedStage from './org-pre-approved-stage/OrgPreApprovedStage';
import ProfileSettings from './org-switching/ProfileSettings';
import OtpInput from './otpInput/OtpInput';
import PageTitle from './page-title/PageTitle';
import Pagination from './pagination/Pagination';
import PaymentCollection from './payment-collection/PaymentCollection';
import PendingVerification from './pending-verification/PendingVerification';
import PlusNChipList from './plus-n-chip-list/PlusNChipList';
import PreviewModal from './preview-modal/PreviewModal';
import PreviousPageButton from './previous-page-button/PreviousPageButton';
import ProgressBar from './progress-bar/ProgressBar';
import RadioButton from './radio-button/RadioButton';
import RadioGroup from './radio-button/RadioGroup';
import RadioCard from './radio-card/RadioCard';
import ReportDateRangePicker from './report-date-range-picker/ReportDateRangePicker';
import RequestRejected from './request-rejected/RequestRejected';
import ReuploadDocument from './reupload-document/ReUpload';
import RoundedTabs from './rounded-tabs/RoundedTabs';
import SearchBar from './searchbar/SearchBar';
import SectionTitle from './section-title/SectionTitle';
import ShareModal from './share-modal/ShareModal';
import SidebarItem from './sidebar-item/SidebarItem';
import Spinner from './spinner/Spinner';
import StatusTag from './status-tag/StatusTag';
import Switch from './switch/Switch';
import Table from './table/Table';
import TablePageIndicator from './table/TablePageIndicator';
import TabNavigation from './TabNavigation';
import Tabs from './tabs/Tabs';
import TagInput from './tag-input/TagInput';
import TagSelector from './tag-selector/TagSelector';
import TextArea from './text-area/TextArea';
import ThreeDotActionButton from './three-dot-action-button/ThreeDotActionButton';
import Toast from './toast/Toast';
import Tooltip from './tooltip/Tooltip';
import DayPicker from './week-day-picker/DayPicker';

const MultiBarChart = lazy(
  () => import('./apex-chart/multi-bar-chart/MultiBarChart')
);
const LineChart = lazy(() => import('./apex-chart/line-chart/LineChart'));

const SemiCircleGuageChart = lazy(
  () => import('./apex-chart/semi-circle-gauge-chart/SemiCircleGuageChart')
);

const PdfViewer = lazy(() => import('./pdf-viewer/PdfViewer'));

export {
  Accordion,
  AccountFooter,
  ActionButton,
  AddMemberModal,
  Address,
  AmountInput,
  AmountInputTooltip,
  Avatar,
  BackWithCustomText,
  BarLineComboChart,
  BlacklistedModal,
  Breadcrumbs,
  BusinessNameInfoBanner,
  Button,
  Checkbox,
  Chip,
  ConfirmationModal,
  ContactSupport,
  CopyToClipboard,
  CountryCode,
  DatePicker,
  DateRangePicker,
  DayPicker,
  DonutChart,
  DowntimeTimer,
  Drawer,
  Dropdown,
  DropDownActionButton,
  DropdownWithRadoiButton,
  EditTagModal,
  EmptyScreen,
  FeeConfigInput,
  FloatingBottomBar,
  GroupCard,
  Icon,
  ImageUpload,
  ImageUploadBranch,
  InfiniteScroll,
  InfoCard,
  InfoIconTooltip,
  Input,
  Label,
  LabelledNumberStepper,
  LineChart,
  LogoUpload,
  MobileNumberInput,
  Modal,
  MulitSelectDropdownWithApplyButton,
  MultiBarChart,
  MultiFieldFilter,
  MultiProgressBar,
  MultiSelectDropdown,
  MultiSelectDropdownV2,
  MultiSelectFilter,
  MultiSelector,
  MultiSelectorWithChips,
  MultiUpload,
  NextPageButton,
  Notification,
  OrgPreApprovedStage,
  OtpInput,
  PageTitle,
  Pagination,
  PaymentCollection,
  PdfViewer,
  PendingVerification,
  PlusNChipList,
  PreviewModal,
  PreviousPageButton,
  ProfileSettings,
  ProgressBar,
  RadioButton,
  RadioCard,
  RadioGroup,
  ReportDateRangePicker,
  RequestRejected,
  ReuploadDocument,
  RoundedTabs,
  SearchBar,
  SectionTitle,
  SemiCircleGuageChart,
  ShareModal,
  SidebarItem,
  Spinner,
  StatusTag,
  Switch,
  Table,
  TablePageIndicator,
  TabNavigation,
  Tabs,
  TagInput,
  TagSelector,
  TextArea,
  ThreeDotActionButton,
  Toast,
  Tooltip
};
